/** YYYY-MM-DD for local calendar today. */
export function localTodayYmd(now = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** True when the visit/day ended before today (local). */
export function isPastVisitDate(
  departureDate: string | null | undefined,
  arrivalDate: string | null | undefined,
  now = new Date()
): boolean {
  const end = (departureDate || arrivalDate || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(end)) return false;
  return end < localTodayYmd(now);
}

/**
 * True when an itinerary item's clock time on dayDate is still in the future
 * (or has no time). Used for collapsePastItems.
 */
export function isItemStillUpcoming(
  dayDate: string | null | undefined,
  timeHm: string | null | undefined,
  now = new Date()
): boolean {
  const day = (dayDate || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return true;
  const today = localTodayYmd(now);
  if (day > today) return true;
  if (day < today) return false;
  const hm = (timeHm || '').trim();
  const match = /^(\d{1,2}):(\d{2})/.exec(hm);
  if (!match) return true;
  const itemMinutes = Number(match[1]) * 60 + Number(match[2]);
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  return itemMinutes >= nowMinutes;
}
